var _title, _path, _polygon, _path2, _polygon2, _polygon3, _path3, _path4, _path5, _path6, _polygon4, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon5, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _polygon6, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _polyline, _path34, _path35, _path36, _polyline2, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _line, _path44, _rect, _rect2, _rect3, _circle, _path45, _path46, _path47, _path48, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path49, _polygon7, _path50, _polygon8, _polygon9, _polygon10, _path51, _circle9, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _ellipse;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLateCheckOut = function SvgLateCheckOut(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "30 0 185 170",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Late Check-Out")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.8,97.9v.2h.7Z",
    fill: "none"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "178.4 96 199.9 101.1 201.3 128.2 200.8 98.1 178.4 96",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.5,60.8,175.1,48.2v.3l17.2,11.6-17.1-3.9v3.1H171l-5.5,4,11.2-4.6,18.7,5.3-21,.2L168.9,69l14.3-2.4L162.4,85.9s20-17.7,24.8-17.8l7-.4s-11.4,4.2-14.3,11.8c0,0,12-10.9,17.4-7.8l-7.8,5.1,9.5-3.1-1.3,16.2-14.9-8,14.5,10.5-25.7-7.3s-8.6,4.9-9.9,7.7c0,0,7-5.3,12.3-4s22.8,7.7,26.8,9.1l-.7-37.1Z",
    fill: "none"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "175.1 56.4 171 59.2 175.1 59.3 175.1 56.4",
    fill: "#fff4d0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "172.3 46.6 175.1 48.5 175.1 48.2 172.3 46.6",
    fill: "#fff4d0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.9,139.1c38.3,1.9,40.5,8.8,61.1.3,18.1-7.5,33.8-41.5,22.5-79.5C183.3,15.2,117.9,9.6,115.4,9.2,82.9,3.4,61.6,46.8,61.6,46.8c-31.7,0-26.7,73-7.9,92.9C71,157.9,82.1,137.6,112.9,139.1Z",
    fill: "#fff4d0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178.4,96l21,2a.7.7,0,0,1,.1-.5c-5.7-2.1-21.3-7.7-25.5-8.7s-12.3,4-12.3,4c1.3-2.8,9.9-7.7,9.9-7.7l25.7,7.3L182.8,81.9l14.9,8L199,73.7l-9.5,3.1,7.8-5.1c-5.4-3.1-17.4,7.8-17.4,7.8,2.9-7.6,14.3-11.8,14.3-11.8l-7,.4c-4.8.1-24.8,17.8-24.8,17.8l20.8-19.3L168.9,69l5.5-4.9,21-.2-18.7-5.3-1.4.6v.3h-.8l-9,3.7,5.2-3.7H119.3V9.7l-3.9-.5h-.5V59.5H58.5v-.3L59,47c-28.8,4-23.6,73.4-5.3,92.7s28.4-2.1,59.2-.6c38.3,1.9,40.5,8.8,61.1.3,11.1-4.6,21.3-19.2,24.9-38.5Z",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.3,59l3.5-2.5V48.4l-2.6-1.8,2.6,1.5V30.2c-19.4-14.3-45-19-55.2-20.5V59Z",
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.6,60.3a.6.6,0,0,0-.1-.4c-3.7-12.7-11.6-22.2-21.1-29.3V48.3Z",
    fill: "none"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "192.3 60.1 175.3 48.7 175.3 56.3 192.3 60.1",
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.4,59V9l-1.8-.2-10.4.7C77.2,15,61.6,46.8,61.6,46.8l-2.1.2L59,59Z",
    fill: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5,59.5h56.4V9.1h-.5V59H59l.5-12H59l-.5,12.2Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.2,9.5l10.4-.7A32.6,32.6,0,0,0,102.2,9.5Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M170.7,59.5l.6-.5H119.7V9.7h-.4V59.4Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M198.9,100.9c.2-1,.3-1.9.5-2.9l-21-2Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M196.6,60.3l-21.3-12V30.6l-.5-.4V48.1l-2.6-1.5,2.6,1.8v8.1L171.3,59l-.6.5-5.2,3.7,9-3.7h.8v-.3l1.4-.6,18.7,5.3-21,.2L168.9,69l14.3-2.4L162.4,85.9s20-17.7,24.8-17.8l7-.4s-11.4,4.2-14.3,11.8c0,0,12-10.9,17.4-7.8l-7.8,5.1,9.5-3.1-1.3,16.2-14.9-8,14.5,10.5-25.7-7.3s-8.6,4.9-9.9,7.7c0,0,7-5.3,12.3-4s19.8,6.6,25.5,8.7A87.8,87.8,0,0,0,196.6,60.3Zm-21.3-4V48.7l17,11.4Z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M199.4,112.2a70.7,70.7,0,0,0-7.6,3.5c-5.3,2.8-5.3,4.7-5.3,4.7l3.3,6.1C194.3,122.6,199.2,118.2,199.4,112.2Z",
    fill: "#bc6734"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "166.4 94.5 188.3 123 193.9 117.8 180.9 103.4 166.4 94.5",
    fill: "#bc6734"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M112.9,139.1c38.3,1.9,40.5,8.8,61.1.3,18.1-7.5,33.8-41.5,22.5-79.5C183.3,15.2,117.9,9.6,115.4,9.2,82.9,3.4,61.6,46.8,61.6,46.8c-31.7,0-26.7,73-7.9,92.9C71,157.9,82.1,137.6,112.9,139.1Z",
    fill: "none"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6,132.8s7.7,5.6,19.1,1.4,13.1-9.6,13.1-9.6Z",
    fill: "#395c6e"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.3,133.1v12.8l-36.1,8V156l39.4-6.2-.2-18.1H105S105.5,132.9,105.3,133.1Z",
    fill: "#395c6e"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M111.2,133.2V146l36.1,7.7v2.1L107.9,150V131.8h3.5S110.9,133,111.2,133.2Z",
    fill: "#395c6e"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M173.3,148.2a58.5,58.5,0,0,0-7.3-1.7l1.6-9.5-7.5.2-2.5,18c4.9-.2,9.4-.5,13.6-3.2C172.1,151.5,172.8,149.9,173.3,148.2Z",
    fill: "#bc6734"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M173.3,148.2c-.5,1.7-1.2,3.3-2.1,3.8-4.2,2.7-10.6,3.3-15.5,3.5l-.2,1.2s22.8-4.4,23-4.8S176.5,149.1,173.3,148.2Z",
    fill: "#98aab6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7,112.5c1.5,10.4,51.8-26.4,51.8-26.4h.2A61.6,61.6,0,0,1,146,70.4C129.8,79.9,96.7,112.5,96.7,112.5Z",
    fill: "#e7824f"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,112.1s56.2-29.8,74.3-28.4S172,139.5,172,139.5l-15.4,1.7-5-32.9C135.1,107.9,89.2,145.3,86.5,112.1Z",
    fill: "#ed996c"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M126.2,32.6v.3l4.1.4-3.1,15-4.5-.2-.4,1.6s4.8.9,5.9-.2,4-17.3,4-17.3C126.4,30.3,126.2,32.6,126.2,32.6Z",
    fill: "#395c6e"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "130.3 33.3 126.2 32.9 122.7 48.1 127.2 48.3 130.3 33.3",
    fill: "#bbc7d0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96,15.8S108.8,36.1,89.7,38C65,40.5,85.3,17.9,96,15.8Z",
    fill: "#bc6734"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M109.6,53.3c-3.8-3.5-6.9-1.6-7.8-2.6s1.5-4.3-1-8c-3.9-5.6-6.3-.8-7.6-6.1a8.8,8.8,0,0,0-2.4-4.3,10.5,10.5,0,0,0,3.3-5.1c.6-2.4-.4-4.5-.8-6.1s2.9-1.8,3-5.1c0,0-6.1-8.2-16.3-1.6-2.3,1.4,3.6-8.1-5.6-5.8s-9,13.4-2.3,12.6-4.7,4.7.3,10.8.5,5.2.2,11.6,5.2-.1.1,6.8c-3.8,5,2.1,12.8,4.7,14.7,7.4,5.4,10.2,2.8,12.4-1.7C97.4,86.9,118,62.1,109.6,53.3Z",
    fill: "#003449"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M121.2,57c.7-2.4,8.1,0,7.3,1.8L118.2,87.5l-9.8-13.6S115.1,69.7,121.2,57Z",
    fill: "#fdd058"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3,30.2s-2.1-8.8-5.6-5.4,2.8,9.1,2.8,9.1Z",
    fill: "#bc6734"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7,46.2s-6.9,10.2-2.8,29.4,12,38.7,12,38.7l34.8-6.5C120,95.7,105.6,35.9,77.7,46.2Z",
    fill: "#ed996c"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M128.6,39.6c.1,2.1.6,5.9.6,5.9s-4.8,2.3-4.7,4.5l-1.9-.3.2,5.7-1,2.8,5.2.7s7.4-13.7,7-15.7-3.5-10.3-4.1-9.4-.4,3.5-.4,3.5S128.5,37.5,128.6,39.6Z",
    fill: "#bc6734"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7,46.2s-9,16.5,5.2,42.9L102.6,100,106,65.1S97.1,45.2,77.7,46.2Z",
    fill: "#e7824f"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M148.8,51.7c-.7-1.8-2.9-1.3-4.9-1.5h-.2v2.5a7.5,7.5,0,0,0-3.2,1.6c-.2,0-.1,0,0,.1-.8,4.5-.2,5.8.3,7.4-.1,0-.1.1,0,.1a10.6,10.6,0,0,0,3.4,1.2v1.7s.3,1.3,5.8,1.1h.3C150.5,61.1,150.6,56.2,148.8,51.7Zm-4.5,9.8c-.9-.1-2-.8-2.1-3.1a.4.4,0,0,0-.1-.3v-.3c-.1-2.3,1-3.1,1.8-3.4Z",
    fill: "#f0af88"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M149.6,49.1a14.3,14.3,0,0,0-5.7,1.1c2,.2,4.2-.3,4.9,1.5,1.8,4.5,1.7,9.4,1.7,14.3h.1c5.6-.4,5.1-1.6,5.1-1.6l.2-14.7A16.8,16.8,0,0,0,149.6,49.1Z",
    fill: "#f1bb9a"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M140.1,53.4c-.6-.4-.8,1.1-1.5,2.2a7.1,7.1,0,0,1-2.3,1.8,17.2,17.2,0,0,1,.7,2.1l1.7-.6C141.1,57.6,140.8,53.9,140.1,53.4Z",
    fill: "#bc6734"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M101.3,95.8l2.5,15.8S149,86.3,157.6,92.9s3.9,44.6,3.9,44.6",
    fill: "none",
    stroke: "#e7824f",
    strokeMiterlimit: 10,
    strokeWidth: 0.74
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "102.9 60.2 109.3 69.9 110 69.6",
    fill: "none",
    stroke: "#e7824f",
    strokeMiterlimit: 10,
    strokeWidth: 0.74
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M80,59.6s7.8,33.1,20.3,40.8,31.6-21.5,31.6-21.5,5.7-5.4-4-13.6c0,0-14.1,19.2-21.6,19.8S98.6,63.4,95,56.3c-2.7-5.3-6.9-5.5-9.4-5.3S79.6,55.3,80,59.6Z",
    fill: "#fbde8b"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M128.2,66c1-1.4,4.3-6.2,6.6-7.9s8.4-4.1,9.1-3.1-.7,2.3-.5,2.4c3.3,1.9.3,3.4.1,6.7s-8.3,4.4-8.3,4.4l-4.1,3.8Z",
    fill: "#bc6734"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M123,71.4s-.5,9.2,6.5,11",
    fill: "none",
    stroke: "#fdd058",
    strokeMiterlimit: 10,
    strokeWidth: 0.74
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "80 95.2 82.9 94.7 90.4 113.6",
    fill: "none",
    stroke: "#e7824f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.74
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6,132.5c0-1.6,2.5-6.2,17.5-16.5,18.9-13.1,32.9-12.1,46.8-5.6,0,0,3.8,3.5-2.8,7.2s-61.5,19.1-61.5,19.1Z",
    fill: "#395c6e"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5,97.3s0,20.2,14.7,32l10.3-6.2S80.4,82.5,68.5,97.3Z",
    fill: "#395c6e"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1,53.8s7.5,1.3,10.7,13.7c3.8,14.2-3.5,28.7-8.1,32.9S60.4,70.8,60.4,70.8,53.4,47,71.1,53.8Z",
    fill: "#395c6e"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7,53.3S60.6,93,86.5,128.9l-8.9,8.5S51.5,73.1,60.1,54Z",
    fill: "#98aab6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1,128.1l47.8-16.3s11.2-2.8,13.5,2.3c0,0,2.6,10.5-32.9,17s-32.1,6.3-32.1,6.3Z",
    fill: "#98aab6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M153.1,67.9c-1.5-.3-4,.7-7.1,2.5a54.4,54.4,0,0,0,2.2,15c7.4,1.6,17.3,4.8,18.2,13.5,1.4,12.2,9.8,17.3,12.6,20.6l8.9-8.2S162.6,69.3,153.1,67.9Z",
    fill: "#e7824f"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M199.4,112.2c-.2,6-6.3,11.6-10.8,15.4l.6,1.2L202.1,115S207.9,108.9,199.4,112.2Z",
    fill: "#bbc7d0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 156.2,
    y1: 137.7,
    x2: 172.2,
    y2: 136.6,
    fill: "none",
    stroke: "#e7824f",
    strokeMiterlimit: 10,
    strokeWidth: 0.74
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7,100.1S62.9,86,69.1,86s2.8,15.2,2.8,15.2H65.2Z",
    fill: "#a4d2bb"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 87,
    width: 1,
    height: 14.07,
    transform: "translate(-0.9 0.7) rotate(-0.6)",
    fill: "#98aab6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 68.6,
    y: 86.1,
    width: 1,
    height: 14.96,
    fill: "#98aab6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70.7,
    y: 86.9,
    width: 1,
    height: 14.12,
    fill: "#98aab6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.6,
    cy: 100.6,
    r: 4,
    fill: "#b5dac9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3,102.8l.4-2h-16l.4,2.4A64.3,64.3,0,0,0,78.3,102.8Z",
    fill: "#e98c5c"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1,103.2l.3,1.3c4.9.2,9.7.1,14.5.5l.4-2.2A64.3,64.3,0,0,1,63.1,103.2Z",
    fill: "#ed996c"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9,105c-4.8-.4-9.6-.3-14.5-.5l.5,2.8c4.6-.2,9.1-.5,13.7-.6Z",
    fill: "#e98c5c"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9,107.3l.4,2H77.1l.5-2.6C73,106.8,68.5,107.1,63.9,107.3Z",
    fill: "#ed996c"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.9,
    cy: 98.4,
    r: 0.3,
    fill: "#98aab6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 99,
    r: 0.3,
    fill: "#98aab6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.1,
    cy: 99.9,
    r: 0.3,
    fill: "#98aab6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.1,
    cy: 99.6,
    r: 0.3,
    fill: "#98aab6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.6,
    cy: 97.4,
    r: 0.3,
    fill: "#98aab6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.8,
    cy: 98.2,
    r: 0.3,
    fill: "#98aab6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.1,
    cy: 100.1,
    r: 0.3,
    fill: "#98aab6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4,144.2a97,97,0,0,0,30.9,0l-2.9-7.8H69.7Z",
    fill: "#e2e6ec"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "101.2 109.2 80.8 109.2 59.9 109.2 61.1 111.8 100.1 111.8 101.2 109.2",
    fill: "#e2e6ec"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3,156.1a70.2,70.2,0,0,0,40.6,0l-1.1-2.9H62.5Z",
    fill: "#e2e6ec"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "65.1 120.8 68 127.4 93.7 127.4 96.4 120.8 65.1 120.8",
    fill: "#e2e6ec"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "100.1 111.8 61.1 111.8 65.1 120.8 96.4 120.8 100.1 111.8",
    fill: "#bfd2db"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "70.9 133.7 69.7 136.4 94.4 136.4 92.3 130.9 93.7 127.4 68 127.4 70.9 133.7",
    fill: "#bfd2db"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5,153.2c13.6,2.3,26.4,2.4,38.3,0l-3.5-9a97.1,97.1,0,0,1-30.9,0Z",
    fill: "#bfd2db"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.2,
    cy: 114.8,
    r: 6.3,
    fill: "#fdd058"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M139.1,126.5s2.6-1,4.5-6.1l-5.7,2.3Z",
    fill: "#c27342"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M127.1,123.3s-9.3,7.9-6.6,16.3,9.2-5.7,9.2-5.7Z",
    fill: "#c27342"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M125.5,131c.6-13.1,5.8-10.9,5.8-10.9l3.7-5.5c.1.6.2,1.1.9,1.2a3.5,3.5,0,0,0,3-1.7,5.2,5.2,0,0,1,2.2,4.5c.3,11,1.7,5.6-.6,18.6C140.5,137.2,125.4,134.7,125.5,131Z",
    fill: "#bc6734"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M135.9,115.8c-.7-.1-.8-.6-.9-1.2l.6-.6c1-1,2.2-.7,3.3.1A3.5,3.5,0,0,1,135.9,115.8Z",
    fill: "#395c6e"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M126.8,135.7c-5.3,3.7-14.4,7.1-30.1,5.3h-.2s-8.6-2.3-7,6.1,25.2,11.6,25.2,11.6,20,3.3,22.6-19.3C133.8,138.5,130.3,137,126.8,135.7Z",
    fill: "#bc6734"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5,137c-2.5-1.9-5.6-2.5-8.7-2.9l-2,1.6c3.5,1.3,7,2.8,10.5,3.8C137.4,138.7,137.4,137.9,137.5,137Z",
    fill: "#e98c5c"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M132.4,145.9s-3.9,13.5-3.2,13.7,1.1-.1,1.5,1.3-4.6,1.6-5.4,1.4-1.8.3-3.3-7.3S132.4,145.9,132.4,145.9Z",
    fill: "#bc6734"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M135.6,145s-2.8,9.7-2.3,9.9.8-.1,1.1.9-3.3,1.2-3.8,1-1.4.2-2.4-5.3S135.6,145,135.6,145Z",
    fill: "#bc6734"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M92,141.9c-5.5-2.3-4.1-8.3-5-8.2s-3.8,8.1,4.1,12.2C100.6,150.9,97.5,144.3,92,141.9Z",
    fill: "#bc6734"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3,154.2a9.6,9.6,0,0,1,.5,5.8c-.9,3.3,3.1,2.9,3.1,2.9s2.2.1,2.1-.6-3.2.9-.7-7.4",
    fill: "#bc6734"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1,150.6a37.4,37.4,0,0,1,.5,5.8c-.1,3.1,3.1,2.9,3.1,2.9s2.1.2,2.1-.5-3.2.8-.7-7.5",
    fill: "#bc6734"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1,142.7s-4.8,3.9.6,15.4c2.3,5,2.3-5.7,12.9-1.9C108.6,157.9,90.1,142.7,90.1,142.7Z",
    fill: "#bc6734"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M132.3,128.7s9.8-3.9,10.2,6.8-.8,12.9-2.2,15-8-6-7.2-12.6S131.2,128.5,132.3,128.7Z",
    fill: "#c27342"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M122.7,48.1V40.8s1.3-4,2.3-4-1.3,7.3-1.3,7.3",
    fill: "#bc6734"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150,
    cy: 50.6,
    rx: 5,
    ry: 1,
    transform: "translate(-2.3 7.5) rotate(-2.8)",
    fill: "#bc6734"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLateCheckOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/late-check-out.c768e500.svg";
export { ForwardRef as ReactComponent };